import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyCarHandover from "./component";
import { withRouter } from "react-router-dom";
import { getCarHandOverDetails } from "./actions";
import { setCarHandoverDetails, setPageLoading } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy,
    repeatUserTransition: {
        pageLoading
    }
}) => ({
    postInspectionDiy,
    pageLoading
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getCarHandOverDetailsConnect: getCarHandOverDetails,
    setCarHandoverDetailsConnect: setCarHandoverDetails,
    setPageLoadingConnect: setPageLoading
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyCarHandover));
